//Menu
let hamicon = document.querySelector(".hamicon");
let nav = document.querySelector(".only-mobile-menu .main-navigation");
let hamMenu = document.querySelector(".main-navigation.hamburger-menu");
const mq = window.matchMedia("(max-width: 959px)");

//Ham Menu
if (hamMenu) {
    hamMenu.style.display = "none";
}

let primaryMenu = Array.prototype.slice.call(document.querySelectorAll(".primary-menu"));

mq.onchange = (e) => {
    if (mq.matches) {
        if (nav) {
            nav.style.display = "none";
        }
        if (hamicon) {
            hamicon.style.display = "block";
        }
        if (document.querySelector(".mobile-menu-icon")) {
            document.querySelector(".mobile-menu-icon").style.display = "block";
        }
    } else {
        if (nav) {
            nav.style.display = "block";
        }
        if (hamicon) {
            hamicon.style.display = "none";
        }
        if (document.querySelector(".mobile-menu-icon")) {
            document.querySelector(".mobile-menu-icon").style.display = "none";
        }

        primaryMenu.forEach((menu) => {
            menu.style.height = "auto";
        });
    }
};
mq.onchange();

let openMobileNav = (e) => {
    hamicon.classList.toggle("is-active");
    if (nav) {
        nav.classList.toggle("active");
    }
    document.getElementById("content").classList.toggle("filterblur");
    document.getElementById("overlay").classList.toggle("active");
    document.getElementsByTagName("BODY")[0].classList.toggle("no-scroll");
    if (nav) {
        nav.focus();
    }

    let menuLabel = document.querySelector(".mobile-menu-label");
    let menuParentList = primaryMenu[1];

    if (document.querySelector(".menu-with-cta").children.length == 0 || document.querySelector(".menu-with-cta .ham-menu")) {
        menuParentList = primaryMenu[0];
    }

    let menuFromTop = menuParentList.getBoundingClientRect().top;

    menuParentList.classList.toggle("active-submenu");

    if (menuLabel) {
        if (nav.classList.contains("active")) {
            menuLabel.innerText = "Close";
            hamicon.setAttribute("aria-label", "close the menu");
            menuParentList.style.height = "calc(100vh - " + menuFromTop + "px)";
        } else {
            menuLabel.innerText = "Menu";
            hamicon.setAttribute("aria-label", "open the menu");
        }
    }
};

if (hamicon) {
    if (document.querySelector(".menu-with-cta .ham-menu")) {
        nav = document.querySelector(".main-navigation");
    }

    //nav = document.querySelector(".main-navigation");
    hamicon.style.display = "block";
    hamicon.addEventListener("click", openMobileNav);
    hamicon.addEventListener("keydown", (e) => {
        if (e.keyCode == 13 || e.keyCode == 32) {
            openMobileNav();
        }
    });
}

//Submenu Arrow Icon
var arrowchevron = document.createElement("div");
arrowchevron.classList.add("arrow-down");
arrowchevron.setAttribute("tabindex", -1);
arrowchevron.setAttribute("role", "button");

let parentMenu = document.querySelectorAll(".menu-item-has-children > a");
let allparentMenu = Array.prototype.slice.call(parentMenu);
allparentMenu.forEach((menu) => {
    let parentName = menu.textContent;
    menu.setAttribute("aria-haspopup", true);
    menu.setAttribute("aria-expanded", false);
    menu.onclick = (event) => {
        event.preventDefault();
      };
    menu.appendChild(arrowchevron.cloneNode(true));
    let arrow = menu.children[0];
    arrow.setAttribute("aria-label", "Open " + parentName + " Submenu");
});


// three level menu js start   

//rotate 2nd level menu to left 
let elementArrow = document.querySelectorAll('.three-level-menu-container ul li ul li a .arrow-down');
elementArrow.forEach((arrowthirdlevel) => {
    arrowthirdlevel.classList.add('rotate-left');
});

// Remove no-js class from html
document.documentElement.classList.remove("no-js");

//interact with no sub menu -> working
let li_with_no_submenu = document.querySelectorAll('li.menu-item:not(.menu-item-has-children)');
li_with_no_submenu.forEach((list_text) => {
    list_text.addEventListener("click", function (e) {
        let linkATag = list_text.querySelector("a").getAttribute("href");
        window.location.href = linkATag;
    })

});


// When interacting with a li that has a sub menu
//for opening menu and setting values of a and ul tag
let openSubmenuTask = (childUl, childA) => {
    childUl.classList.remove("js-hideElement");
    childUl.classList.add("js-showElement");
    childA.querySelector('.arrow-down').classList.add('rotate');
    childA.setAttribute("aria-expanded", true);
    childA.classList.add("js-openSubMenu");
}

//for closing menu and setting values of a and ul tag
let closeSubmeutask = (childUl, childA) => {
    childUl.classList.remove("js-showElement");
    childUl.classList.add("js-hideElement");
    childA.querySelector('.arrow-down').classList.remove('rotate');
    childA.setAttribute("aria-expanded", false);
    childA.classList.remove("js-openSubMenu");
}

let liWithChildhren = document.querySelectorAll('li.menu-item-has-children');
liWithChildhren.forEach((liwithchild) => {
    //mouseover function
    liwithchild.addEventListener("mouseover", function () {
        let ul = liwithchild.querySelector("ul");
        let atag = liwithchild.querySelector("a");
        openSubmenuTask(ul, atag);
    });

    //mouseleave function
    liwithchild.addEventListener("mouseleave", function () {
        let ul = liwithchild.querySelector("ul");
        let atag = liwithchild.querySelector("a");
        closeSubmeutask(ul, atag);
    });

    //click function
    liwithchild.addEventListener("click", function (e) {
        if (e.target.parentElement == liwithchild) {
            e.preventDefault();
            let ul = liwithchild.querySelector("ul");
            let atag = liwithchild.querySelector("a");
            if (atag.classList.contains("js-openSubMenu")) {
                closeSubmeutask(ul, atag);
            } else {
                openSubmenuTask(ul, atag);
            }
            // return false;
        }

    });
});


//second level closing menu on focus out
let lastChildofUl = document.querySelectorAll('.three-level-menu-container ul li ul li:last-child');
lastChildofUl.forEach(getLastChild => {
    getLastChild.addEventListener("keydown", function (e) {
        var getUl = getLastChild.parentElement;
        var getATag = getUl.previousElementSibling;
        var menukeyCode = e.keyCode || e.which;
        var menushiftCode = e.shiftKey;
        if (menushiftCode == false && menukeyCode == 9) {
            if (getLastChild.querySelector('a').classList.contains('js-openSubMenu')) {

            } else {
                closeSubmeutask(getUl, getATag);
            }
        }
    })

});


//for shift tab
let firstChildofUl = document.querySelectorAll('.three-level-menu-container ul li ul li:first-child');
firstChildofUl.forEach(getFirstChild => {
    getFirstChild.addEventListener("keydown", function (e) {
        if (e.target.parentElement == getFirstChild) {
            var getUl = getFirstChild.parentElement;
            var getATag = getUl.previousElementSibling;
            var menukeyCode = e.keyCode || e.which;
            var menushiftCode = e.shiftKey;
            if (menushiftCode == true && menukeyCode == 9) {
                closeSubmeutask(getUl, getATag);
            }
        }

    })
});


//for triggerin the close icon after focusing out the menu -> working 
let mainUlContainer = document.querySelectorAll(".three-level-menu-container li:last-child a");
for(let i = 0; i < mainUlContainer.length; i++){
    mainUlContainer[i].addEventListener("focusout", function (e) {
    
        setTimeout(function () {
            //var focus_ele = document.activeElement;
            //if (!(focus_ele.classList.contains("three-level-menu-container") || mainUlContainer.contains(document.activeElement))) {
                e.preventDefault();
                document.querySelector('.hamicon').focus();
           // }
        }, 0);
    })
}


// leaving focus last a tag
// let mainUlContainerla = document.querySelectorAll(".three-level-menu-container li:last-child a");
// for(let i = 0; i < mainUlContainerla.length; i++){
//     // mainUlContainerla[i].addEventListener("focus", function (e) {
//     //     console.log("gettong focus");
//     //     setTimeout(function () {
//     //         // var focus_ele = document.activeElement;
//     //         // if (!(focus_ele.classList.contains("three-level-menu-container") || mainUlContainer.contains(document.activeElement))) {
//     //             e.preventDefault();
//     //             document.querySelector('.hamicon').focus();
//     //         // }
//     //     }, 0);
//     // })
//     mainUlContainerla[i].addEventListener("focusout", function (e) {
//         console.log("leaving focus");
//         setTimeout(function () {
//             // var focus_ele = document.activeElement;
//             // if (!(focus_ele.classList.contains("three-level-menu-container") || mainUlContainer.contains(document.activeElement))) {
//                 e.preventDefault();
//                 document.querySelector('.hamicon').focus();
//             // }
//         }, 0);
//     })
// }
